import { useCallback, useState } from 'react';

import { UseMultiStepStateType } from './types';

export default function useStateStep({ initialStep }: UseMultiStepStateType) {
  const [inViewStep, setInViewStep] = useState(initialStep);

  const setStep = useCallback(
    (step: string) => {
      setInViewStep(step);
    },
    [setInViewStep],
  );

  return {
    inViewStep,
    setStep,
  };
}
